import { render, staticRenderFns } from "./ChristmasGreetingsDecoration.vue?vue&type=template&id=52d152e9&"
import script from "./ChristmasGreetingsDecoration.vue?vue&type=script&lang=js&"
export * from "./ChristmasGreetingsDecoration.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasGreetingsDecoration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports